module.exports = __webpack_public_path__ + "img/empty-state-invoice.1693a807.svg";